(() => {
  const sectionId = 'mega-menu-products';
  const responseCache = new Map();

  const getRequest = (collectionUrl) => {
    const url = new URL(collectionUrl, window.location.origin);

    if (url.origin !== window.location.origin) {
      throw new Error('Collection URL must use the storefront origin.');
    }

    url.hash = '';
    url.searchParams.delete('section_id');

    const cacheKey = url.toString();
    url.searchParams.set('section_id', sectionId);

    return { cacheKey, requestUrl: url.toString() };
  };

  const fetchCards = (collectionUrl) => {
    const { cacheKey, requestUrl } = getRequest(collectionUrl);

    if (!responseCache.has(cacheKey)) {
      const request = fetch(requestUrl, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Unable to load collection products (${response.status}).`);
          }

          return response.text();
        })
        .then((html) => {
          const responseTemplate = document.createElement('template');
          responseTemplate.innerHTML = html;

          const fragment = responseTemplate.content.querySelector('[data-products-mega-menu-fragment]');

          if (!fragment) {
            throw new Error('Collection products response is missing its fragment.');
          }

          return fragment.innerHTML;
        })
        .catch((error) => {
          responseCache.delete(cacheKey);
          throw error;
        });

      responseCache.set(cacheKey, request);
    }

    return responseCache.get(cacheKey);
  };

  const showLoading = (list) => {
    const loadingItem = document.createElement('li');
    loadingItem.className = 'products-mega-menu__loading';
    loadingItem.setAttribute('role', 'status');
    loadingItem.innerHTML = `
      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
      <span></span>
    `;
    loadingItem.querySelector('span').textContent = list.dataset.loadingText || 'Loading...';
    list.replaceChildren(loadingItem);
  };

  const loadProducts = async (list) => {
    if (!list || list.dataset.loadState === 'loading' || list.dataset.loadState === 'loaded') {
      return;
    }

    list.dataset.loadState = 'loading';
    list.setAttribute('aria-busy', 'true');
    showLoading(list);

    try {
      const cardsHtml = await fetchCards(list.dataset.collectionUrl);
      const template = document.createElement('template');
      const limit = Number.parseInt(list.dataset.productLimit, 10) || 5;

      template.innerHTML = cardsHtml;
      list.replaceChildren(...Array.from(template.content.children).slice(0, limit));
      list.dataset.loadState = 'loaded';
    } catch (error) {
      list.replaceChildren();
      list.dataset.loadState = 'idle';
      console.error('Mega menu products:', error);
    } finally {
      list.removeAttribute('aria-busy');
    }
  };

  const activateDesktopItem = (item) => {
    const menu = item.closest('products-mega-menu');

    menu?.querySelectorAll('.products-mega-menu__item--active').forEach((activeItem) => {
      activeItem.classList.remove('products-mega-menu__item--active');
    });
    item.classList.add('products-mega-menu__item--active');
  };

  const initializeList = (list) => {
    if (list.dataset.loaderInitialized === 'true') {
      return;
    }

    const desktopItem = list.closest('.products-mega-menu__item');

    if (desktopItem) {
      const trigger = desktopItem.querySelector(':scope > a[id^="ProductsMegaMenu-Link"]');
      let hoverTimer;

      if (!trigger) {
        return;
      }

      desktopItem.addEventListener('pointerenter', () => {
        activateDesktopItem(desktopItem);
        hoverTimer = window.setTimeout(() => loadProducts(list), 100);
      });
      desktopItem.addEventListener('pointerleave', () => window.clearTimeout(hoverTimer));
      trigger.addEventListener('focus', () => {
        activateDesktopItem(desktopItem);
        loadProducts(list);
      });

      // The first item has --active from the Liquid template.
      // Load its products immediately so users see content on menu open
      // without waiting for hover.
      if (desktopItem.classList.contains('products-mega-menu__item--active')) {
        loadProducts(list);
      }

      list.dataset.loaderInitialized = 'true';
      return;
    }

    const submenu = list.closest('.menu-drawer__submenu');
    const details = submenu?.previousElementSibling;

    if (!details?.matches('details[id^="Details-menu-drawer-submenu-"]')) {
      return;
    }

    details.addEventListener('toggle', () => {
      if (details.open) {
        loadProducts(list);
      }
    });
    if (details.open) {
      loadProducts(list);
    }

    list.dataset.loaderInitialized = 'true';
  };

  const initialize = (root = document) => {
    if (root.matches?.('[data-products-mega-menu-list]')) {
      initializeList(root);
    }
    root.querySelectorAll?.('[data-products-mega-menu-list]').forEach(initializeList);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
